import { api, plainApi } from "../api/client";
import { convertToSafeName } from "./strings";

export interface UploadResponse {
  media_id: string;
  upload_url: string;
}

export const uploadFileToS3 = async (
  file: File | string, 
  sopId?: string, 
  onProgress?: (progress: number) => void
): Promise<UploadResponse | string | undefined> => {
  if (!file) return;
  if (typeof file === "string") return file;

  // if (file.size > 10 * 1024 * 1024) {
  //   alert("File size exceeds 10MB");
  //   return;
  // }

  try {
    // Set correct MIME type for STEP files
    let fileType = file.type;
    if (file.name.toLowerCase().endsWith('.stp') || file.name.toLowerCase().endsWith('.step')) {
      fileType = 'application/step';
    }
    
    const fileTypeEncoded = encodeURIComponent(fileType);
    const fileName = convertToSafeName(file.name);
    const url = `/upload_url?content_type=${fileTypeEncoded}&file_name=${fileName}${sopId ? `&sop_id=${sopId}` : ''}`;
    const res = await api.get(url);
    const { upload_url, media_id } = res.data;

    if (!upload_url || !media_id) {
      throw new Error("Invalid response from server");
    }

    await plainApi.put(upload_url, file, {
      headers: {
        "Content-Type": fileType,
        "Content-Disposition": `inline; filename=${fileName}`,
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(progress);
        }
      },
    });

    return { media_id, upload_url };
  } catch (error) {
    console.error("Error:", error);
    throw new Error("Failed to upload file to S3");
  }
};
